import React, { useEffect } from "react"
import { Icon, Label, Table } from "semantic-ui-react"
import { useGetPaginatedAuditHistory } from "../../../Hooks/FetchHooks/GetDataService/getOrganizationData/useGetPaginatedAuditHistory"
import BifrostTable from "../../BifrostElementComponent/BifrostTable/BifrostTable"

const BifrostAuditComponent = ({ chosenItem, chosenItemType }) => {
	const { data, isLoading, pagination, setPagination, getAuditHistory } = useGetPaginatedAuditHistory(chosenItem, chosenItemType)

	const auditHeaderColumns = React.useMemo(
		() => [
			{ name: "Timestamp (UTC)", key: "timestamp", type: "date" },
			{ name: "Action", key: "action", type: "string" },
			{ name: "Target", key: "field_name", type: "string" },
			{ name: "New Value", key: "new_value", type: "string" },
			{ name: "Done By", key: "username", type: "string" }
		],
		[]
	)

	const actionColors = {
		CREATE: "green",
		UPDATE: "yellow",
		DELETE: "red",
		RESET: "grey"
	}

	const valueColors = {
		Enabled: "olive",
		Disabled: "orange"
	}

	const actionIcons = {
		CREATE: "plus",
		UPDATE: "edit",
		DELETE: "remove",
		RESET: "redo"
	}

	const objectIcons = {
		users: "user",
		device_configs: "setting"
	}

	const AuditRow = ({ item }) => (
		<Table.Row key={item.timestamp}>
			<Table.Cell>{item.timestamp}</Table.Cell>
			<Table.Cell>
				<Label color={actionColors[item.action]}>
					<Icon name={actionIcons[item.action]} />
					{item.action.toUpperCase()}
				</Label>
			</Table.Cell>
			<Table.Cell>
				<Label color="gray">
					<Icon name={objectIcons[item.object]} /> {item.field.toUpperCase()}
				</Label>
			</Table.Cell>
			<Table.Cell>{item.new_value && <Label color={valueColors[item.new_value]}>{item.new_value}</Label>}</Table.Cell>
			<Table.Cell>{item.email}</Table.Cell>
		</Table.Row>
	)

	const filterAudit = (audit, filter) =>
		!filter || filter === ""
			? true
			: audit.type.toLowerCase().includes(filter.toLowerCase()) ||
			  (audit.username && audit.username.toLowerCase().includes(filter.toLowerCase())) ||
			  audit.timestamp.toLowerCase().includes(filter.toLowerCase()) ||
			  (audit.details && audit.details.toLowerCase().includes(filter.toLowerCase()))

	useEffect(() => {
		if (!data || !data.length) {
			getAuditHistory(pagination)
		}
		// return () => setData([])
	}, [])

	return (
		<BifrostTable
			pageName="Audit"
			loading={isLoading}
			data={data}
			columns={auditHeaderColumns}
			Row={AuditRow}
			pagination={pagination}
			setPagination={setPagination}
			filterFunc={filterAudit}
			defaultSort={{ order: "descending", column: "timestamp" }}
			fetchData={getAuditHistory}
		/>
	)
}

export default BifrostAuditComponent
